<ng-container *transloco="let t; read: 'conversation-message-template-editor-first-send'">
  <app-distinguished-conversation-message-template-editor
    [cardTitle]="t('title')"
    [tempateType]="firstSend"
    [textBoxLabel]="t('label')"
    [textBoxPlaceholder]="t('placeholder')"
  ></app-distinguished-conversation-message-template-editor>
</ng-container>
